<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display"  v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>
                        Combine Marks Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        @change="getStd()"
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list" item-text="display_name" item-value="id" label="Semester" persistent-hint hint="Please select semester" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="getDiv();getStandardCourse()"
                        persistent-hint
                        hint="Please select standard"
                        @click="putnull"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list" item-text="div_name" label="Division" outlined persistent-hint hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="crs_id"
                        return-object
                        :items="crs_list"
                        item-text="course"
                        label="Course"
                        outlined
                        persistent-hint
                        hint="Please select course"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && crs_id">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card flat v-if="ay_std_div_list != null">
            <v-col cols="12" sm="12" md="12" v-if="learner_data_list!=''">
                <v-btn  class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    
                <!-- <v-col sm="2">
                    <v-btn rounded  color="success" outlined @click="fnExcelReport('my-table-id','combine_sheet');" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
                </v-col> -->
                <div id="my-table-id">
                     <v-row dense justify="center">
                        <v-col cols="12" sm="12" md="12">
                            <center>
                                <br />
                                <strong><h6> <span v-if="org_basic_data.trust_name"> {{org_basic_data.trust_name}}</span></h6></strong>
                                <strong> <span v-if="org_basic_data.school_name">{{org_basic_data.school_name}}</span> </strong><br />
                                <strong> <span>Terminal Exam Marklist - {{academicyear}}</span> </strong><br />
                            </center>
                        </v-col>
                    </v-row>
                     <v-col cols="12" sm="12" md="12">
                     <v-row dense justify="center">
                        <v-col cols="12" sm="4" md="4"><strong><h5>Class Teacher : {{class_teacher}} </h5></strong></v-col>
                        <v-col cols="12" sm="4" md="4"><strong><h5>Subject Teacher : {{inst_name}} </h5></strong></v-col>
                        <v-col cols="12" sm="2" md="2"><strong><h5>Course : <span v-for="(crs,index) in course" :key="index"> <span v-if="index!=0"> + </span>{{crs}}</span>  </h5></strong></v-col> 
                        <v-col cols="12" sm="2" md="2"><strong><h5> Class : {{standard}} {{division}} </h5></strong> </v-col> 
                     </v-row>
                      </v-col>
                 <v-simple-table fixed-header  dense class="elevation-1">
                    <thead>
                        <tr>
                            <td rowspan="2">Roll No</td>
                            <td rowspan="2">Name</td>
                            <td :colspan="rubics_formative_list_size">
                               <center> (A) {{ass_details_for_marksheet_formative[0]}}({{formative_total_converted}}) </center>
                            </td>
                            <td><center></center></td>
                            <td :colspan="rubics_summative_list_size">
                                <center> (B) {{ass_details_for_marksheet_sumative[0]}}({{summative_total_converted}}) </center>
                            </td>
                             <td><center></center></td>
                             <td rowspan="2"><center>Total (A + B) = C</center></td>
                             <td rowspan="2"><center>Grade</center></td>
                             <td rowspan="2"><center>Observation</center></td>
                        </tr>
                        <tr>
                            <td v-for="(header,index) in rubics_formative_list" :key="index">
                                <center>{{index}} ({{header}}) </center>
                            </td>
                            <td><center>Total</center></td>
                             <td v-for="(header,index) in rubrics_summative_list" :key="index">
                               <center> {{index}}  ({{header}}) </center>
                            </td>
                            <td><center>Total</center></td>
                        </tr>
                    </thead>
                     <tbody>
                        <tr v-for="(c,index) in learner_data_list" :key="index">
                            <td>{{c.roll_no}}</td>
                            <td>{{c.name}}</td>
                            <td v-for="(header,index1) in c.formative_assement_type" :key="index1"><center>{{header}}</center></td>
                            <td><center>{{c.formative_Marks[0]}}</center></td>
                            <td v-for="header in c.summative_assement_type" :key="header"><center>{{header}}</center></td>
                            <td><center>{{c.summative_Marks[0]}}</center></td>
                            <td><center>{{c.overall_marks_total}}</center></td>
                            <td><center>{{c.grade}}</center></td>
                            <td><center>{{c.remark}}</center></td>
                        </tr>
                    </tbody>
                </v-simple-table>
                </div>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                selected: [],
                snackbar: false,
                course_list: [],
                crs_id: null,
                search: "",
                crs_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                assessment_detail_list: [],
                assessment_detail: [],
                standard: null,
                division: null,
                course: null,
                rubricsScheme: null,
                academicyear: null,
                inst_name: null,
                rtotal: null,
                org_basic_data: [],
                learner_data_list:[],
                ass_details_for_marksheet_formative:[],
                ass_details_for_marksheet_sumative:[],
                rubics_formative_list:[],
                rubrics_summative_list:[],
                rubics_formative_list_size:null,
                rubics_summative_list_size:null,
                formative_total_converted:null,
                summative_total_converted:null,
                inst_name:null,
                rtotal:null,
                class_teacher:null,
                org_basic_data:[],
            };
        },

        methods: {
             fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
                tab_text = tab_text + '<x:Name>Test Sheet</x:Name>';
                tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
                tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $('#' + id).clone();
                exportTable.find('input').each(function (index, elem) { $(elem).remove(); });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + '</table></body></html>';
                var fileName = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

                //Save the file
                // var blob = new Blob([tab_text], { type: "application/vnd.ms-excel;charset=utf-8" })
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
                },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            putnull2() {
                (this.assessment_detail_list = []), (this.assessment_detail = []);
            },
            getreport() {
                //alert("this.assessment_detail::"+this.assessment_detail)
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.sem,
                    div: this.div.div_off_id,
                 //   rubric_assessment_detail: this.assessment_detail,
                };
                this.fetch_loader = true;
                axios
                    .post("/ZealExamination/getMarksData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_data_list = res.data.learner_data_list
                            this.ass_details_for_marksheet_formative = res.data.ass_details_for_marksheet_formative
                            this.ass_details_for_marksheet_sumative = res.data.ass_details_for_marksheet_sumative
                            this.rubics_formative_list = res.data.rubics_formative_list
                            this.rubrics_summative_list = res.data.rubrics_summative_list
                            this.rubics_formative_list_size=res.data.rubics_formative_list_size
                            this.rubics_summative_list_size=res.data.rubrics_summative_list_size
                            this.formative_total_converted = res.data.formative_total_converted
                            this.summative_total_converted = res.data.summative_total_converted
                            this.standard = res.data.standard
                            this.division = res.data.div
                            this.course = res.data.course
                            this.academicyear = res.data.ay
                            this.learner_course_list = res.data.learner_marks_list
                            this.inst_name = res.data.inst_name
                            this.class_teacher = res.data.class_teacher
                            this.org_basic_data = res.data.org_basic_data
                            this.fetch_loader = false;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {});
            },
            getassessmentschemedetails() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id.c_id,
                    sem: this.sem,
                };
                axios
                    .post("/ZealExamination/getassessmentscheme", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getStandardCourse() {
                // let div = this.div.div_id;
                // if (this.div.div_id) {
                //     div = this.div.div_id;
                // } else {
                //     div = this.div;
                // }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                };
                axios
                    .post("/Examination/getStandardCourseCombine", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.courses_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered for this standard..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                // this.div_list = ["All"];
                // this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                // this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //     this.sel_ay_data = res.data.curr_ay;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: small !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
</style>
